export class SearchValidator {
  constructor() {
    this._validator = null;
  }
  set validator(specificValidator) {
    this._validator = specificValidator;
  }
  get validator(){
    return this._validator;
  }
  validate(input) {
    return this._validator.validate(input);
  }
  getParam(input){
    const {inputValue} = input
    return this._validator.getParam(inputValue);
  }
}

const licensePlateDictonary = {
  "&" : 1,
  "#" : 1,
  "?": 1,
  "$": 1,
  "/": 1,
  "=": 1,
  "*": 1,
  "+": 1,
  "@": 1,
  " ": 1,
  '"': 1,
  "!": 0.5,
  ":": 0.5,
  ".": 0.5,
  ",": 0.5,
  "'": 0.5, 
  "-": 0.5,
}

//TODO: Create env variables for REGEX
export class LicensePlateValidator {
  validate(license) {
    let isLicensePlateValid = false
    let regExValidation = "A-Z0-9"
    Object.keys(licensePlateDictonary).forEach( (prop)=> {
      prop == " " ? regExValidation += "\\s" : 
      prop == "/" ? regExValidation += "\\/" :
      regExValidation += prop
    })
    let dynamicRegEx = new RegExp(`^([${regExValidation}]*)$`);
    if (dynamicRegEx.test(license.toUpperCase())) {
      let licenseSpace = 0;
      Object.keys(license).forEach((char) => {
        const licensePlateChar = license[char];
        const licensePlateCharSpecialValue = licensePlateDictonary[licensePlateChar]
        const charSpace = licensePlateCharSpecialValue ? licensePlateCharSpecialValue: 1;
        licenseSpace += charSpace;
      });

      isLicensePlateValid = licenseSpace >= 1 && licenseSpace <= 8
    }
    return isLicensePlateValid;
  }
  getParam(license){
    const licenseEncoded = encodeURIComponent(license)
    return {customerInfo: `?license_plate=${licenseEncoded.toUpperCase()}`};
  }
}

export class EmailValidator {
  validate(email) {
    return /^\w+([\.!#\/$%&'*+=?^`{|}~-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }
  getParam(email){
    const emailEncoded = encodeURIComponent(email)
    return {customerInfo: `?email=${emailEncoded}`};
  }
}

export class PhoneValidator {
  validate(phone) {
    return /^(?:\(?([0-9]{3})\)?[-.●\s]?)?([0-9]{3})[-.●]?([0-9]{4})$/.test(
      phone
    );
  }
  getParam(phone){
    return {customerInfo:`?phone=${phone}`};
  }
}

export class CustomerNameValidator {
  validate(customerName) {
    return /^[A-Za-z0-9\s.'-]*$/.test(customerName);
  }
  getParam(customerName){
    return {customerInfo:`?customer_name=${customerName}`};
  }
}

export class OrderIdValidator {
  constructor (args) {
    this.orderType = args.orderType;
  }

  validate(orderId) {
    return /^\d+$/.test(
      orderId
    );
  }
  getParam(orderId){
    const cleanOrderId = Number(orderId).toString();
    return {customerInfo:`/${cleanOrderId}?type=${this.orderType}`};
  }
}